module.exports = __webpack_public_path__ + "img/maestro-alt.eadcbf7e.svg";